import { FC } from "react";
import { ProductFacet } from '@/data/types/Product';
import { Button } from "@mui/material";
import { useLocalization } from "@/data/Localization";

type Props = {
    facetItem: ProductFacet & {
        showMore: boolean,
        showLess: boolean
    },
    toggleFacetLimit: (facetValue: string) => () => void
}

export const ShowMoreLess:FC<Props> = ({facetItem, toggleFacetLimit}) => {

    const productFilterNLS = useLocalization('ProductFilter');
    
    return(
        <Button
            variant="inline"
            data-testid={`productFilter_${facetItem.name}_show_more`}
            id={`productFilter_${facetItem.name}_show_more`}
            onClick={toggleFacetLimit(facetItem.value)}
            sx={{ mb: 1 }}
        >
            {facetItem.showMore
                ? productFilterNLS.Actions.showMore.t()
                : productFilterNLS.Actions.showLess.t()}
        </Button>
    );
}